var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCancelCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8364 19.8373L11.9023 11.9023M11.9032 19.8373L19.8373 11.9023",
    stroke: "#2177FE",
    strokeWidth: 1.98374,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0949 15.8698C29.0949 8.56588 23.1739 2.64488 15.8699 2.64488C8.56602 2.64488 2.64502 8.56588 2.64502 15.8698C2.64502 23.1737 8.56602 29.0947 15.8699 29.0947C23.1739 29.0947 29.0949 23.1737 29.0949 15.8698Z",
    stroke: "#2177FE",
    strokeWidth: 1.98374
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelCircle);
export default __webpack_public_path__ + "static/media/cancelCircle.c747dde62c761eecec2bc34ab981fb41.svg";
export { ForwardRef as ReactComponent };